/**
 * Dashboard tab of a prospect's preview site (2026-09-21) - real, live functionality: place a
 * test order through this same storefront, watch it move through the real print-queue statuses.
 * Gated behind the secret presentationAccessKey a rep hands the prospect - see
 * account-provisioning.service.ts's provisionPreviewAccountFromLead and shared-ui's
 * PreviewKeyGate/DashboardPreview, which do the actual work; this is just the thin per-app wrapper.
 */
import React from 'react';
import { PreviewKeyGate, DashboardPreview } from 'shared-ui';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { usePortal } from '../context/PortalContext';
import { getApiBaseUrl } from '../services/api';

export default function DashboardPage() {
  const { businessId, loading } = usePortal();

  if (loading || !businessId) {
    return (
      <>
        <Header />
        <main style={{ marginTop: 80, minHeight: '60vh' }} />
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <main style={{ marginTop: 80, minHeight: '60vh' }}>
        <PreviewKeyGate apiBaseUrl={getApiBaseUrl()} businessId={businessId}>
          {(previewKey) => <DashboardPreview apiBaseUrl={getApiBaseUrl()} businessId={businessId} previewKey={previewKey} />}
        </PreviewKeyGate>
      </main>
      <Footer />
    </>
  );
}
